<template>
  <div class="one_step">
    <div class="step_shell for_pb">
      <div class="outcome_message" v-if="product==='dairy'">
        You may be eligible for a Dairy Direct loan, but we need to check a few things first. 
        Our team will give you a call within the next two business hours on the number you provided in your application.
      </div>
      <div class="outcome_message" v-else>
        You may be eligible for a Sheep &amp; Beef Direct loan, but we need to check a few things first. 
        Our team will give you a call within the next two business hours on the number you provided in your application.
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        product: ''          
      }
    },
    created: function() {  
      var app = this.$parent.$parent.application;
      this.product = app.product;                 
    }
  }
</script>